<div class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800/40">
  <div class="mb-2.5 inline-flex items-center gap-1.5 text-lg font-semibold text-neutral-900 dark:text-white">
    sumário financeiro
  </div>

  <div class="flex items-center justify-between py-1.5 text-sm">
    <span class="text-neutral-500 dark:text-neutral-400">subtotal dos itens</span>
    <span class="font-mono tabular-nums text-neutral-900 dark:text-neutral-100">{{ formatCents(financial.itemsSubtotal) }}</span>
  </div>

  <div class="flex items-center justify-between py-1.5 text-sm">
    <span class="text-neutral-500 dark:text-neutral-400">juros</span>
    <span class="font-mono tabular-nums text-neutral-900 dark:text-neutral-100">{{ formatCents(financial.totalInterest) }}</span>
  </div>

  <div class="flex items-center justify-between py-1.5 text-sm">
    <span class="text-neutral-500 dark:text-neutral-400">frete</span>
    <span class="font-mono tabular-nums text-neutral-900 dark:text-neutral-100">{{ formatCents(financial.shipping) }}</span>
  </div>

  <div class="flex items-center justify-between py-1.5 text-sm">
    <span class="text-neutral-500 dark:text-neutral-400">total de ajustes</span>
    <span class="font-mono tabular-nums"
      [ngClass]="{
        'text-emerald-500 dark:text-emerald-400': financial.totalAdjustments < 0,
        'text-rose-500 dark:text-rose-400': financial.totalAdjustments > 0,
        'text-neutral-900 dark:text-neutral-100': financial.totalAdjustments === 0
      }">
      {{ formatAdjustment(financial.totalAdjustments) }}
    </span>
  </div>

  <div class="my-1.5 h-px bg-neutral-200 dark:bg-neutral-700"></div>

  <div class="flex items-baseline justify-between pt-1.5">
    <span class="text-sm font-semibold text-neutral-900 dark:text-white">Valor total</span>
    <span class="font-mono text-2xl font-bold tabular-nums text-neutral-900 dark:text-white">{{ formatCents(financial.grandTotal) }}</span>
  </div>
</div>
